import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-f4092a16"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "top"
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = {
  class: "info"
};
const _hoisted_4 = {
  class: "course"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "所属课程：", -1));

const _hoisted_6 = {
  class: "text"
};
const _hoisted_7 = {
  class: "semester"
};

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "学期：", -1));

const _hoisted_9 = {
  class: "text"
};
const _hoisted_10 = {
  class: "chapter"
};

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "章节：", -1));

const _hoisted_12 = {
  class: "text"
};
const _hoisted_13 = {
  class: "bottom"
};
const _hoisted_14 = {
  class: "avatar"
};
const _hoisted_15 = ["src"];
const _hoisted_16 = {
  class: "left"
};
const _hoisted_17 = {
  class: "teacher-info"
};
const _hoisted_18 = {
  key: 0
};
const _hoisted_19 = {
  class: "create-time"
};
export default /*#__PURE__*/_defineComponent({
  props: {
    caseData: {
      type: Object
    }
  },

  setup(__props) {
    const props = __props;
    const menuInfo = inject('menuInfo');
    const $utils = inject('$utils');

    const goCaseDetail = () => {
      const {
        site_id
      } = props.caseData;
      const menuName = menuInfo.value.nav_name || menuInfo.value.module_name;
      const menuId = menuInfo.value.menu_id;
      const pageInfo = {
        url: window.location.origin + `/teachingCenterList.html?menuId=${menuId}&name=${menuName}`,
        name: menuName
      };
      window.localStorage.setItem('currentPage', JSON.stringify(pageInfo));
      window.location.href = `/caseDetailFront.html?siteId=${site_id}&type=5&menuId=${menuId}`;
    };

    return (_ctx, _cache) => {
      return __props.caseData ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "list-item",
        onClick: goCaseDetail
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(__props.caseData.case_name), 1), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("span", _hoisted_6, _toDisplayString(__props.caseData.course_name), 1)]), _createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("span", _hoisted_9, _toDisplayString(__props.caseData.term_name), 1)]), _createElementVNode("div", _hoisted_10, [_hoisted_11, _createElementVNode("span", _hoisted_12, _toDisplayString(__props.caseData.outline_name), 1)])])]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("img", {
        src: __props.caseData.avatar || require('@/assets/images/common/teacher_icon.png'),
        alt: ""
      }, null, 8, _hoisted_15)]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createTextVNode(_toDisplayString(__props.caseData.teacher_name) + " ", 1), __props.caseData.organ_name ? (_openBlock(), _createElementBlock("span", _hoisted_18, "·" + _toDisplayString(__props.caseData.organ_name), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_19, " 创建更新：" + _toDisplayString(_unref($utils).formatDate(__props.caseData.create_time, 'YYYY.MM.DD')), 1)])])])) : _createCommentVNode("", true);
    };
  }

});